import { createFileRoute } from '@tanstack/react-router';
import { BlogList } from '@/pages/blog/BlogList';

export const Route = createFileRoute('/_admin/blog/')({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: search.tab === 'published' ? 'published' : 'drafts',
  }),
  component: BlogList,
});
